/**
 * The focus presentation (focus / review / deliverables), mirrored across
 * desktop windows. Commands write this store first when a presentation
 * starts or changes and last when it ends; the renderer's adapter draws it.
 */
import { create } from "zustand";
import { mirroredStore } from "@/lib/mirrored-store";
import type { PresentationState } from "@/lib/focus/focus-types";

export interface PresentationStoreState {
  presentation: PresentationState | null;
  setPresentation: (p: PresentationState | null) => void;
  setPresentationActiveIndex: (i: number) => void;
}

export const usePresentationStore = create<PresentationStoreState>()(
  mirroredStore("presentation", (set) => ({
    presentation: null,

    setPresentation: (presentation) => set({ presentation }),

    setPresentationActiveIndex: (i) =>
      set((state) => {
        if (!state.presentation) return state;
        return { presentation: { ...state.presentation, activeIndex: i } };
      }),
  })),
);

/** The running presentation's variant, or null. */
export const usePresentationVariant = () =>
  usePresentationStore((s) => s.presentation?.variant ?? null);
